const paths = {
    login: 'login-path'
  };
  
  
  async function fetchBackend(endpoint, method, auth, body, params) {
    let headers = {
      Accept: 'application/json'
    };
  
    // Only set Content-Type for non-FormData bodies
    if (!(body instanceof FormData)) {
      headers['Content-Type'] = 'application/json';
    }
  
    const fetchObject = { method, headers };
    const path = paths[endpoint] || endpoint;
    let url = `${process.env.REACT_APP_BACKEND_URL_ADMIN}${path}`;
    // let url = `https://api.greenzonetechnologies.com.ng/medicals/api${path}`;
  
  
  
  
    if (body) {
      // Don't stringify FormData
      fetchObject.body = body instanceof FormData ? body : JSON.stringify(body);
    }
  
    if (params) {
      const paramsArray = Object.keys(params).map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`);
  
      url += `?${paramsArray.join('&')}`;
    }
  
    if (auth) {
      const token = sessionStorage.getItem('token');
      if (token) {
        headers.Authorization = `${token}`;
      }
    }
  
  
  
    return fetch(url, fetchObject)
      .then(checkHttpStatus)
      .then(parseJSON);
  }
  
  export const get = (endpoint, params, auth = true) => fetchBackend(endpoint, 'GET', auth, null, params);
  
  export const post = (endpoint, body, auth = true) => fetchBackend(endpoint, 'POST', auth, body);
  
  export const put = (endpoint, body, auth = true) => fetchBackend(endpoint, 'PUT', auth, body);
  
  export const del = (endpoint, body, auth = true) => fetchBackend(endpoint, 'DELETE', auth, body);
  
  function checkHttpStatus(response) {
    if (response && response.ok) {
      return response;
    }
  
    if (response && [400, 401, 404, 422, 409, 500].includes(response.status)) {
      return response;
    }
  
    const errorText = response && response.statusText ? response.statusText : 'Unknown Error';
    const error = new Error(errorText);
    error.response = response;
    throw error;
  }
  
  function parseJSON(response) {
    if (!response) return null;
    if (response.status === 204) return null;
    return response.json();
  }
  
  